import { useState } from "react";
import { Link } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { Loader2, MailCheck, ArrowLeft } from "lucide-react";
import { Logo } from "@/components/Logo";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e?.preventDefault();
    setErr(""); setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim() });
      setSent(true);
    } catch (e) { setErr(apiError(e)); } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-white text-[#0F0F12] px-6" data-testid="forgot-page">
      <div className="w-full max-w-[360px]">
        <div className="mb-8"><Logo height={28} /></div>
        {sent ? (
          <div data-testid="forgot-sent" className="text-center">
            <div className="w-12 h-12 rounded-full bg-[#FC82ED]/15 border border-[#FC82ED]/40 flex items-center justify-center text-[#FC82ED] mx-auto mb-4"><MailCheck size={22} /></div>
            <h2 className="font-display text-xl font-bold mb-2">Controlla la tua email</h2>
            <p className="text-sm text-slate-500 mb-6" data-testid="forgot-sent-msg">Se l'email è registrata, riceverai un link per reimpostare la password. Il link è valido 30 minuti e si può usare una sola volta.</p>
            <Link to="/login" className="inline-flex items-center gap-1.5 text-sm text-[#FC82ED] font-medium"><ArrowLeft size={15} /> Torna al login</Link>
          </div>
        ) : (
          <form onSubmit={submit}>
            <h2 className="font-display text-[1.7rem] font-bold tracking-tight mb-1.5">Password dimenticata?</h2>
            <p className="text-sm text-slate-500 mb-7">Scrivi l'email del tuo account: il link arriverà solo all'indirizzo salvato nel CRM.</p>
            <label className="block text-[11px] font-semibold uppercase tracking-wider text-slate-500 mb-1.5">Email</label>
            <input data-testid="forgot-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
                   className="w-full mb-5 px-3.5 py-2.5 rounded-lg bg-white border border-slate-200 focus:border-[#FC82ED] focus:ring-2 focus:ring-[#FC82ED]/20 outline-none text-sm transition-all" placeholder="nome@immobilart.info" />
            {err && <div data-testid="forgot-error" className="mb-4 text-sm text-red-600 bg-red-50 border border-red-200 rounded-lg px-3 py-2">{err}</div>}
            <button data-testid="forgot-submit" type="submit" disabled={loading}
                    className="w-full py-3 rounded-lg bg-[#FC82ED] hover:bg-[#e06dd2] text-black font-semibold text-sm transition-colors flex items-center justify-center gap-2 disabled:opacity-60">
              {loading && <Loader2 size={16} className="animate-spin" />} Invia link di reset
            </button>
            <Link to="/login" className="mt-5 inline-flex items-center gap-1.5 text-sm text-slate-500 hover:text-[#111111]"><ArrowLeft size={15} /> Torna al login</Link>
          </form>
        )}
      </div>
    </div>
  );
}
